import { useMemo, useState } from "react";
import { DataTable } from "primereact/datatable";
import localeText from "../../../../locale";
import { normalizeText } from "../../utils/adminUtils";
import SearchInput from "./SearchInput";
import EmptyState from "./EmptyState";

// Lista de cadastro com busca local e botão "Novo". As linhas precisam de `searchText`.
const CatalogTable = ({
  rows,
  loading,
  loadError,
  onReload,
  searchPlaceholder,
  createLabel,
  onCreate,
  minWidth = "40rem",
  sortField,
  sortOrder = 1,
  emptyIcon = "pi pi-inbox",
  children,
}) => {
  const [search, setSearch] = useState("");

  const filteredRows = useMemo(() => {
    const term = normalizeText(search.trim());
    return term ? rows.filter((row) => row.searchText?.includes(term)) : rows;
  }, [rows, search]);

  const hasFilters = !!search.trim();

  return (
    <section className="admin-list__card">
      <div className="admin-list__toolbar">
        <SearchInput value={search} onChange={setSearch} placeholder={searchPlaceholder} />
        <span className="admin-list__result-count">
          {loading ? "" : `${filteredRows.length} ${localeText("adminUsersResults")}`}
        </span>
        {onCreate && (
          <button type="button" className="admin-btn admin-btn--primary" onClick={onCreate}>
            <i className="pi pi-plus" aria-hidden="true" />
            {createLabel}
          </button>
        )}
      </div>

      <div className="admin-list__table">
        <DataTable
          value={filteredRows}
          dataKey="id"
          loading={loading}
          paginator
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate={localeText("showingFirstToLast")}
          sortField={sortField}
          sortOrder={sortOrder}
          removableSort
          scrollable
          tableStyle={{ minWidth }}
          emptyMessage={
            loadError ? (
              <EmptyState
                icon="pi pi-exclamation-triangle"
                message={localeText("adminListLoadError")}
                actionLabel={localeText("adminUsersRetry")}
                onAction={onReload}
              />
            ) : (
              <EmptyState
                icon={emptyIcon}
                message={localeText(hasFilters ? "adminListNoResults" : "adminListEmpty")}
                actionLabel={hasFilters ? localeText("adminUsersClearFilters") : null}
                onAction={() => setSearch("")}
              />
            )
          }
        >
          {children}
        </DataTable>
      </div>
    </section>
  );
};

export default CatalogTable;
